import { PropertyServiceData } from "../api-client/api-client";

export function GetCompassCompanyID(): number {
	return 10743;
}

export interface MainDocumentType {
	label: string;
	templateName: string;
}

export interface SupplierDocumentType {
	label: string;
	templateName: string;
	showIfCompass: boolean;
	showIfExternal: boolean;
}

export enum CompanyType {
	Company = 0,
	Customer = 1,
	Supplier = 2,
	Owner = 3
}

export interface DocumentTypes {
	main: MainDocumentType[];
	supplier: SupplierDocumentType[];
}
export interface Refs {
	profile: {
		toggle: (event: Event) => void;
	};
	settings: {
		toggle: (event: Event) => void;
	};
}

export interface PropertyDashboardComponent {
	loadServicesAndSearch(): void;
}

export interface EmailTemplateComponent {
	validateAndSendEmail(): void;
}
export interface FileDataInterface {
	data: File;
	fileName: string;
}

export function GetDocumentTypes(): DocumentTypes {
	return {
		main: [
			{
				label: 'BWOF',
				templateName: 'BwofTemplate'
			},
			{
				label: 'Evacuation Report',
				templateName: 'EvacuationReport'
			},
			{
				label: 'Inspection Summary Defect Report',
				templateName: 'InspectionTemplate'
			},
			{
				label: 'Amendment to Compliance Schedule',
				templateName: 'ComplianceTemplate'
			},
		],
		supplier: [
			{
				label: 'Contractor IQP Statement',
				templateName: 'ContractorIQPStatementTemplate',
				showIfCompass: true,
				showIfExternal: true
			},
			{
				label: '12A Certificate of Compliance',
				templateName: 'CertificateOfComplianceTemplate',
				showIfCompass: true,
				showIfExternal: false
			},
			{
				label: '12A Certificate Request',
				templateName: 'CertificateOfComplianceTemplateExternal',
				showIfCompass: false,
				showIfExternal: true
			},
			{
				label: 'Report In Lieu of Form12A',
				templateName: 'ReportInLieuOfForm12ATemplate',
				showIfCompass: true,
				showIfExternal: true
			},
		]
	};
}

export function GetBwofServiceID(): number {
	return 1;
}

export function GetTrialEvacServiceID(): number {
	return 2;
}

export function GetOwnerInspectionServiceId(): number {
	return 54;
}

export function GetReadyBwofSubServiceDays(): number {
	return 180;
}

export function GetInlineLogoListLimit(): number {
	return 5;
}

export function GetMaxLogoFileSizeBytes(): number {
	return 500 * 1024;
}

export function Get12aPropertyServicesForSupplier(services: PropertyServiceData[], propertyId: number, supplierId: number): PropertyServiceData[]
{
	if (services.length == 0)
		return [];

	return services.filter(s =>
		s.whenDeleted == null
		&& s.active == true
		&& s.propertyId == propertyId
		&& s.supplierCompanyId == supplierId
		&& s.serviceId != GetBwofServiceID()
		&& s.parentServiceId == GetBwofServiceID()
	);
}
